import { render, staticRenderFns } from "./FormInputSplitYearMonth.vue?vue&type=template&id=78f92978&lang=pug"
import script from "./FormInputSplitYearMonth.vue?vue&type=script&lang=ts"
export * from "./FormInputSplitYearMonth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports